"use strict";

/// <reference types="jquery"/>
var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
$(function () {
    var $requeteur = $("#requeteur");
    if ($requeteur.length === 0) {
        return;
    }
    var $selectProfil = $requeteur.find("#select-profils"),
        $selectReporting = $requeteur.find("#select-reporting"),
        $selectColumns = $requeteur.find("#select-column"),
        $saveButton = $requeteur.find("#save-profil"),

    //On crée un handler pour déselection de colonne pour éviter des effets de bord.
    unselectColumn = function unselectColumn(e) {
        e.stopImmediatePropagation();
        var $this = $(this),
            data = $this.parent().data("data"),
            selected = $selectColumns.val();
        selected.splice(selected.indexOf(data.id), 1);
        $selectColumns.val(selected).trigger("change");
    },
        currentProfilConfig = null;
    $.fn.BuildDatatableParams = function (d) {
        if (currentProfilConfig) {
            d = currentProfilConfig;
            currentProfilConfig = null;
        }
        var reporting = $.GetReporting();
        if (reporting) {
            d.customVars = __assign({}, d.customVars, { reporting: reporting });
        }
        return d;
    };
    $.fn.UpdateColumnDisplayList = function (columns) {
        $selectColumns.val($selectColumns.val().concat(columns)).trigger("change.select2");
    };
    $.GetReporting = function () {
        var reporting = $selectReporting.val();
        return reporting == 0 ? null : reporting;
    };
    $.GetDatatableComponent = function () {
        return $requeteur.find(".vue-datatable")[0]["component"];
    };
    $requeteur.on("change", "#select-profils", function () {
        var dt = $.GetDatatableComponent(),
            conf = $(this).find("option:selected").data("configuration");
        dt.search_input_value = conf.search ? conf.search.value : "";
        dt.columns.map(function (c) {
            var colReq = conf.columns.find(function (col) {
                return col.name == c.name;
            });
            dt.setVisibleColumn(c, colReq ? colReq.visible : false);
            var searchArray = [];
            if (colReq) {
                c.search = colReq.search;
                if (c.search && c.search.value && c.search.value !== "") {
                    var s = c.search.value.split("|");
                    s.map(function (_) {
                        try {
                            var temp = JSON.parse(_);
                            searchArray.push(temp);
                        } catch (_a) {
                            searchArray.push(_);
                        }
                    });
                    c.search = searchArray;
                } else {
                    c.search = null;
                }
            }
            var dbCol = dt.datatable.columns(c.name + ":name");
            dt.setSearchValues(dbCol, searchArray);
        });
        $selectReporting.val(conf.customVars && conf.customVars["reporting"] ? conf.customVars["reporting"] : 0);
        currentProfilConfig = conf;
        dt.datatable.draw();
    }).on("change", "#select-reporting", function () {
        $selectProfil.val(0);
        var dt = $.GetDatatableComponent();
        dt.emptySearch();
        dt.datatable.draw();
    }).on("click", "#save-profil", function () {
        var $target = $($(this).data("target")),
            $body = $target.find(".modal-body"),
            $title = $target.find(".modal-title");
        $title.text("Enregistrer la requête");
        $body.load("/Requeteur/SaveModal", function () {
            var $radios = $target.find("input:radio[name='profil']"),
                $input = $target.find("input[name='libelle']");
            $radios.off().click(function () {
                if ($(this).val() != "" && $input.val() == "") {
                    $input.val($(this).data("libelle"));
                }
            });
            //Pré cochage
            var partage = $selectProfil.find("option:selected").data("partage");
            $target.find("input:radio[name='profil'][value='" + $selectProfil.val() + "']").click();
            $target.find("input:radio[name='partage'][value='" + partage + "']").click();
            $target.find(".btn-success").off().on("click", function () {
                var libelle = $target.find("input[name='libelle']").val();
                if (libelle == "") {
                    return;
                }
                var request = $.GetDatatableComponent()["paramsAjax"],
                    $dt = $($saveButton.data("target-datatable")),
                    $filters = $dt.find(".datatable-filter");
                $.ajax({
                    url: "/Affaires/SaveProfilListeAffaire",
                    method: "post",
                    data: {
                        configuration: JSON.stringify(request),
                        libelle: libelle,
                        id: $target.find("input:radio[name='profil']:checked").val(),
                        parDefaut: -1,
                        context: 2,
                        partage: $target.find("input:radio[name='partage']:checked").val()
                    },
                    success: function success(d) {
                        $selectProfil.find("option:selected").removeAttr("selected");
                        $selectProfil.append($("<option/>", {
                            value: d.id,
                            selected: "selected"
                        }).text(libelle).attr("data-configuration", d.configuration));
                        $target.find("a[data-dismiss=\"modal\"]").trigger("click");
                    }
                });
            });
            $target.find(".btn-delete").off().on("click", function () {
                var $parent = $(this).parents(".row-profil"),
                    id = $parent.find("input:radio[name='profil']").val(),
                    libelle = $parent.find("label").text();
                if (confirm("Voulez-vous vraiment supprimer la requ\xEAte " + libelle + " ?")) {
                    $.ajax({
                        url: "/Home/DeleteProfilAffaire",
                        method: "get",
                        data: {
                            id: id
                        },
                        success: function success(d) {
                            var $option = $selectProfil.find("option[value=" + id + "]");
                            if ($option.is(":selected")) {
                                $selectProfil.val(0);
                            }
                            $option.remove();
                            if ($parent.find("input:radio[name='profil']").is(":checked")) {
                                $target.find("input:radio[name='profil']#profil-new").click();
                            }
                            $parent.remove();
                        }
                    });
                }
            });
        });
    }).on("change", "#select-column", function (e) {
        e.stopImmediatePropagation();
        var dt = $.GetDatatableComponent(),
            selected = $selectColumns.val();
        dt.columns.map(function (c) {
            dt.setVisibleColumn(c, selected.indexOf(c.name) > -1);
        });
        dt.datatable.draw();
        $selectColumns.parent().find(".select2-selection__choice__remove").off("click", unselectColumn).on("click", unselectColumn);
    }).on("click", "#btn-export-excel", function () {
        $.GetDatatableComponent().downloadCsv();
    }).on("click", ".dropdown-menu", function (e) {
        e.stopImmediatePropagation();
    });
    $selectColumns.select2();
    $selectColumns.parent().find(".select2-selection__choice__remove").off("click").on("click", unselectColumn);
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Requeteur/index.ts
// module id = 615
// module chunks = 0